import { call, put, takeLatest } from "redux-saga/effects";
import { setAuthenticated, setAccessToken, setRefreshToken, setIsLoading } from "../../Containers/App/action";
import { setProfile, setWallet } from "../../Containers/Client/action";
import { getSignInGoogleLink, signIn, signOut, socialSignIn } from "../../Domain/api";
import { setLoginError } from "./action";
import { LOGIN, LOGIN_GOOGLE_URL, LOGIN_SOCIAL, LOGOUT } from "./constants";

export function* doLogin({credential, cbSuccess, navigate }){
    try {
        yield put(setIsLoading(true));
        const response = yield call(signIn, credential);
        const { refreshToken } = response;
        yield put(setAuthenticated(true));
        yield put(setRefreshToken(refreshToken));
        yield put(setProfile(response.client));
        yield put(setIsLoading(false));
        cbSuccess && cbSuccess();
        navigate && navigate("/")
    } catch (error) {
        yield put(setLoginError(error.response.data.message));
        yield put(setIsLoading(false));
    }
}
export function* doLoginGoogle({cbSuccess}){
    try {
        yield put(setIsLoading(true));
        const response = yield call(getSignInGoogleLink);
        yield put(setIsLoading(false));
        cbSuccess && cbSuccess(response.url);
    } catch (error) {
        // yield put(setLoginError(error.response));
        yield put(setIsLoading(false));
    }
}
export function* doLoginSocial({social, auth, cbSuccess}){
    try {
        yield put(setIsLoading(true));
        const data = {
            code: auth,
            social
        }
        const response = yield call(socialSignIn, data);
        const { refreshToken } = response;       
        yield put(setAuthenticated(true));
        yield put(setRefreshToken(refreshToken));
        yield put(setProfile(response?.client));
        yield put(setIsLoading(false));
        cbSuccess && cbSuccess();
    } catch (error) {
        return;
    }
}
export function* doLogout({cbSuccess, action, refreshToken}){
    try {
        if(action)
            yield call(signOut, {refreshToken});
        yield put(setAuthenticated(false));
        yield put(setAccessToken(null));
        yield put(setRefreshToken(null));
        yield put(setProfile(null));
        yield put(setWallet(null));
        cbSuccess && cbSuccess();
    } catch (error) {
        return;
    }
}

export default function* login() {
    yield takeLatest(LOGIN, doLogin);
    yield takeLatest(LOGIN_SOCIAL, doLoginSocial);
    yield takeLatest(LOGIN_GOOGLE_URL, doLoginGoogle);
    yield takeLatest(LOGOUT, doLogout);
}